import { render, staticRenderFns } from "./NotesColumn.vue?vue&type=template&id=18ef74d5&scoped=true"
import script from "./NotesColumn.vue?vue&type=script&lang=js"
export * from "./NotesColumn.vue?vue&type=script&lang=js"
import style0 from "./NotesColumn.vue?vue&type=style&index=0&id=18ef74d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ef74d5",
  null
  
)

export default component.exports